import { REGISTER_LIMITS, REGISTER_PASSWORD_REGEX } from "../constants/register.constants";

// Simple strength model (no zxcvbn). Score = independent rules satisfied:
// length>=8, has number, has symbol, length>=12.
// Levels: 0 empty, 1 weak, 2 fair, 3 good, 4 strong.

export type PasswordStrengthLevel = 0 | 1 | 2 | 3 | 4;

export interface PasswordStrengthResult {
  score: PasswordStrengthLevel;
  rules: {
    minLength: boolean;
    hasNumber: boolean;
    hasSymbol: boolean;
    longLength: boolean;
  };
}

export function scorePassword(value: string): PasswordStrengthResult {
  if (!value) {
    return {
      score: 0,
      rules: {
        minLength: false,
        hasNumber: false,
        hasSymbol: false,
        longLength: false,
      },
    };
  }

  const rules = {
    minLength: value.length >= REGISTER_LIMITS.PASSWORD_MIN,
    hasNumber: REGISTER_PASSWORD_REGEX.HAS_NUMBER.test(value),
    hasSymbol: REGISTER_PASSWORD_REGEX.HAS_SYMBOL.test(value),
    longLength: value.length >= 12,
  };

  const score = Object.values(rules).filter(Boolean).length as PasswordStrengthLevel;
  return { score, rules };
}
